import { createAsyncThunk } from '@reduxjs/toolkit'
import PublicPlaylist from './public-playlist-model'
import {
  delete_publicPlaylist,
  load_publicPlaylists,
  store_publicPlaylist,
} from './publicPlaylist-service'

export const LoadPublicPlaylistsAsync = createAsyncThunk<any, any>(
  'composer/load/publicPlaylist',
  async (params: { uid: string }) => {
    return await load_publicPlaylists(params)
  },
)

export const CreatePublicPlaylistAsync = createAsyncThunk<any, any>(
  'composer/create/publicPlaylist',
  async (params: PublicPlaylist) => {
    return await store_publicPlaylist(params)
  },
)

export const DeletePublicPlaylistAsync = createAsyncThunk<any, any>(
  'composer/delete/publicPlaylist',
  async (params) => {
    return await delete_publicPlaylist(params)
  },
)
